<template>
  <v-dialog v-model="dataOpen" ref="confirm-dialog" :persistent="persistent" max-width="500px">
    <v-card>
      <v-card-title>
        <span>{{ dataTitle }}</span>
        <v-spacer></v-spacer>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <div class="c-msg">{{ dataText }}</div>
        <div v-if="dataErrMsg">
          <span class="c-errmsg">{{ dataErrMsg }}</span>
        </div>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="clr-btn-cancel" flat @click.native="cancel" :disabled="loading && persistent">{{
          $T('button.cancel')
        }}</v-btn>
        <v-btn
          :color="danger ? 'clr-danger' : 'clr-btn'"
          flat
          @click.native="ok"
          :disabled="dataErrMsg != null"
          :loading="loading"
          >{{ $T('button.ok') }}</v-btn
        >
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    open: { type: Boolean, required: false, default: false },
    dialogKey: { type: String, required: false },
    dialogTitle: { type: String, required: false },
    dialogText: { type: String, required: false },
    confirmValue: { required: false },
    errMsg: { type: String, required: false },
    persistent: { type: Boolean, required: false, default: true },
    danger: { type: Boolean, required: false, default: false },
  },
  data() {
    return {
      dataOpen: this.open,
      dataKey: this.dialogKey,
      dataTitle: this.dialogTitle,
      dataText: this.dialogText,
      dataValue: this.confirmValue,
      dataErrMsg: this.errMsg,
      dataPersistent: this.persistent,
      loading: false,
    };
  },
  watch: {
    errMsg(newVal, oldVal) {
      this.loading = false;
      this.dataErrMsg = newVal;
    },
  },
  methods: {
    openDialog(key, title, text, value, persistent) {
      this.dataKey = key;
      this.dataTitle = title;
      this.dataText = text;
      this.dataValue = value;
      this.dataPersistent = persistent;
      this.loading = false;
      this.dataOpen = true;
    },
    closeDialog() {
      this.dataOpen = false;
    },
    setErrMsg(msg) {
      this.dataErrMsg = msg;
      this.loading = false;
    },
    cancel() {
      this.$emit('cancel', this.dataKey, this.dataValue);
      this.dataOpen = false;
    },
    ok() {
      this.loading = true;
      this.$emit('ok', this.dataKey, this.dataValue);
    },
  },
};
</script>

<style scoped>
.v-card__text {
  min-height: 75px;
  padding: 8px 16px 16px 24px;
}
</style>
